import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import propTypes from 'prop-types';
import styles from './PieChart.module.scss';
import { getDefaultChartColors } from '../chart-colors';
import { tooltipConfig, animationConfig } from '../chart-config';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PieChart = ({
  title,
  cutoutTitle,
  labels,
  barTitle,
  chartData,
  cutoutPercentage,
  chartColors,
}) => {
  const resolvedChartColors = chartColors || getDefaultChartColors();
  const total = chartData.reduce((acc, value) => acc + value, 0) || 0;

  const chartDataPercentages = chartData.map(value => {
    if (value === 0) return 0;
    const percentage = (value / total) * 100;
    return percentage % 1 === 0 ? percentage.toFixed(0) : percentage.toFixed(1);
  });

  const updatedLabels = labels.map((label, index) => `${label} (${chartDataPercentages[index]}%)`);

  const chartConfigData = {
    labels: updatedLabels,
    datasets: [
      {
        label: ` ${barTitle || ' '}`,
        data: chartData,
        backgroundColor: resolvedChartColors,
        borderWidth: 0,
        hoverOffset: 6,
        cutout: '70%',
        spacing: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 6,
          boxHeight: 6,
          padding: 16,
          color: '#475260',
          font: { size: 11, weight: '500' },
        },
      },
      tooltip: tooltipConfig,
      datalabels: { display: false },
    },
    animation: animationConfig,
  };

  return (
    <div className={styles.chartCard}>
      <div className={styles.pieChart}>
        <span className={styles.chartTitle}>{title}</span>
        <div className={styles.chartContainer}>
          {total ? (
            <>
              <Doughnut data={chartConfigData} options={options} />
              <div className={styles.cutoutText}>
                <span>{cutoutPercentage || 0}%</span>
                {cutoutTitle ? <p>{cutoutTitle}</p> : null}
              </div>
            </>
          ) : (
            <div className={styles.chartNoData}>
              <span className={styles.noDataTitle}>No data yet</span>
              <span className={styles.noDataDesc}>Data will appear once activity is recorded.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

PieChart.propTypes = {
  title: propTypes.string,
  cutoutTitle: propTypes.string,
  labels: propTypes.array,
  barTitle: propTypes.string,
  chartData: propTypes.array,
  cutoutPercentage: propTypes.any,
  chartColors: propTypes.array,
};

export default PieChart;
